// Module
var code = "<div> <p> Choose a password that's hard to guess. Use uncommon words or phrases and mixed UppercASe. Add numbers and symbols and avoid sequences like 123, asdf, or zzzz. </p> </div> ";
// Exports
export default code;